<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card class="co-loading-novo">
            <v-card-title class="titulo d-flex align-center justify-center text-center">
                <span v-if="!titulo">Aguarde um momento, <br v-if="ehMobile"> buscando dados...</span>
                <span v-else>{{titulo}}</span>
            </v-card-title>

            <v-card-text class="loading d-flex align-center justify-center">
                <v-progress-circular
                    :size="200"
                    :width="10"
                    color="blue-grey"
                    indeterminate>
                    <div class="loading-text">
                        {{ texto }}
                    </div>
                </v-progress-circular>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'LoadingNovo',
    props: {
        dialog: {
            type: Boolean
        },
        texto: {
            type: String,
            default: "Carregando..."
        },
        titulo: {
            type: String,
            default: null
        }
    },
    computed: {
        ehMobile() {
            return this.$vuetify.breakpoint.xsOnly
        }
    }
}
</script>

<style lang="stylus">
.co-loading-novo
    background-color var(--background-200) !important
    height 100%
    width 100%

    .loading
        .loading-text
            font-size 20px

    .titulo
        height 35vh
        font-size 30px !important
        color #607D8B

</style>
